<script>
    import { scale } from 'svelte/transition';
    import { quintOut } from 'svelte/easing';

    import { user } from '../store/authStore';
    import { users } from '../store/users';
    import { page, modal } from '../store/nav';
    import { lists } from '../store/lists';
    import { generateDummyData } from "../db";

    import Nav from './navBar.svelte';
    import Dial from '../components/dial.svelte';
    //const activeLists = $lists.filter(list => list.status == 'active');
    //const shortLists = activeLists.slice(0,5);
    const progress = 0.78;
</script>

<section id="home" in:scale="{{delay: 250, duration: 300, easing: quintOut }}" out:scale="{{delay: 250, duration: 300, easing: quintOut }}" class="z-0 fixed bg-primary top-0 left-0 h-screen w-screen font-primaryBold text-secondary flex flex-col pt-5 pb-3 px-7" >
    <section id="home-main-grid" class="flex flex-col h-full justify-between space-y-3">
        <section id="home-top-bar" class="h-11 flex justify-between items-stretch">
            <div id="home-app-icon" class="w-7 h-7 rounded-full place-self-center" on:click={() => page.route('/menu')} >
                <img src="/img/icon/main.png" alt="ico"/>
            </div>
            <div class="flex">
                <span class="place-self-center text-2xl font-extrabold" on:click={generateDummyData}>Meal Planner</span>
            </div>
            <div id="home-user-profile" on:click={() => page.route('/profile')} class="" >
                {#if $user.isLoggedIn}
                    <div class="btn-sm w-11 h-11">
                        <img src="{$user.photoURL}" class="rounded-full border-2 border-secondary" alt="U" referrerpolicy="no-referrer">
                    </div>
                {:else}
                    <div class="btn-sm w-11 h-11">
                        <img src="#" class="rounded-full border-2 border-secondary" alt="U" referrerpolicy="no-referrer">
                    </div>
                {/if}
            </div>            
        </section>
        <section id="score" class="h-56">
            <Dial {progress} />
            <section id="select-week" class="flex justify-between">
                <div class="text-shade">05/14</div>
                <div class="text-secondary">05/21</div>
                <div class="text-shade">05/28</div>
                <div class="text-shade">06/07</div>
            </section>
            <section id="select-day" class=" flex justify-between">
                <span class="text-shade text-center">M</span>
                <span class="text-shade text-center">T</span>
                <span class="text-secondary text-center">W</span>
                <span class="text-shade text-center">T</span>
                <span class="text-shade text-center">F</span>
                <span class="text-shade text-center">S</span>
                <span class="text-shade text-center">S</span>
            </section>
        </section>
       
        <section id="meal-plan" class="flex grow">
            
            <section id="plan" class="grow flex flex-col justify-between pt-6">
                <section class="flex">
                    <div>Breakfast</div>
                    <div class="grow px-2 text-right">Bagel <span class="text-shade">|</span> Latte</div>
                </section>
                <section class="flex">
                    <div>Lunch</div>
                    <div class="grow px-2 text-right">Greek salad <span class="text-shade">|</span> Yogurt</div>
                </section>
                <section class="flex">
                    <div>Snack</div>
                    <div class="grow px-2 text-right">Oatmeal waffles <span class="text-shade">|</span> Blueberries</div>
                </section>
                <section class="flex">
                    <div>Dinner</div>
                    <div class="grow px-2 text-right">Chicken Tajine <span class="text-shade">|</span> Cucumber salad <span class="text-shade">|</span> Strawberries <span class="text-shade">|</span> Goat cheese</div>
                </section>
            </section>
            
        </section>
        <section id="footer" class="flex h-56 justify-between">
            <section id="users" class="flex flex-col shrink-0 w-20 border border-shade rounded-2xl py-1">
                <div class="text-center">My home</div>
                <section class="flex flex-col space-y-4 py-1.5">
                    {#each $users.slice(0,4) as userProfile}
                        <div class="btn-sm w-11 h-11 m-auto">
                            <img src="/img/profiles/{userProfile.uid}.png" class="rounded-full" alt="U" referrerpolicy="no-referrer">
                        </div>
                    {/each}
                </section>
            </section>
            <section class="grow flex flex-col justify-between">
                <section id="menu" class="grow flex justify-between pl-8">
                    <div on:click={()=>progress=0.28}>Opt 2</div>
                    <div on:click={()=>progress=0.57}>Opt 3</div>
                    <div on:click={()=>progress=0.86}>Opt 4</div>
                </section>
                <section id="shopping-lists" on:click={() => page.route('/lists')} class="flex flex-col justify-items-end">
                    <span class="text-right">Shopping lists</span>
                    <!--section class="flex space-y-4 py-2.5 place-content-end">
                        {#each shortLists as list}
                            <div class="btn-sm w-11 h-11 z-10" on:click|stopPropagation={() => page.route('/lists/items?list_uid='+list.uid)}>
                                {#if list.storeId}
                                    <img alt="" class="rounded-full border border-primary" src="/img/stores/{list.storeLogo}.png" />
                                {:else}
                                    <img alt="" class="w-7" src="/img/icon/retailers/de55.png" />
                                {/if}
                            </div> 
                        {/each}
                    </section-->
                    
                </section>
            </section>
        </section>
    </section>
</section>

    <!--
        
        <section class="outer-border bg-offblue p-2.5 w-40 h-96 flex">
            <section id="myhome" class="bg-offblue grow rounded-sm border-2 border-secondary pt-14 text-center flex flex-col place-content-between" >
                <span>My Plans</span>
                <section class="flex flex-row px-2 flex-wrap gap-3 justify-center">
                    <div class="w-12 h-12 rounded-full bg-sunny pt-3 text-center shadow-md">4/13</div> 
                    <div class="w-12 h-12 rounded-full bg-pink pt-3 text-center shadow-md">4/20</div> 
                    <div class="w-12 h-12 rounded-full bg-mint pt-3 text-center shadow-md">4/27</div>
                </section>
                <div class="btn-sm place-self-center mb-7" on:click|stopPropagation={() => modal.open('/new-item')}>
                    <svg class="m-auto mt-4 w-4 fill-accent" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.75 0.75C6.75 0.335786 6.41421 0 6 0C5.58579 0 5.25 0.335786 5.25 0.75V5.24993L0.75 5.24993C0.335786 5.24993 0 5.58572 0 5.99993C0 6.41414 0.335786 6.74993 0.75 6.74993L5.25 6.74993V11.25C5.25 11.6642 5.58579 12 6 12C6.41421 12 6.75 11.6642 6.75 11.25V6.74993L11.25 6.74993C11.6642 6.74993 12 6.41415 12 5.99993C12 5.58572 11.6642 5.24993 11.25 5.24993L6.75 5.24993V0.75Z"/>
                    </svg>
                </div>
            </section>
        </section>
        <div id="notifications" class="bg-agrume w-20 h-20 rounded-full text-center relative" >
            <div class="btn-sm w-11 h-11 m-auto top-4.5 left-4.5 z-10 absolute">
                <svg class="fill-secondary w-6 h-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6628 2.60796C11.6653 2.57427 11.6666 2.53822 11.6666 2.49967C11.6666 1.5792 10.9204 0.833008 9.99997 0.833008C9.0795 0.833008 8.3333 1.5792 8.3333 2.49967C8.3333 2.53821 8.33461 2.57425 8.33719 2.60794C7.03398 2.79323 6.03972 3.21523 5.29318 3.86504C4.25841 4.76574 3.83981 5.98451 3.60954 7.16687C3.49413 7.75943 3.42029 8.37644 3.35004 8.96661L3.34745 8.98836C3.27687 9.58134 3.20911 10.1507 3.1065 10.7052C2.89907 11.8262 2.56448 12.7903 1.87911 13.5558C1.70972 13.745 1.63584 14.0011 1.67844 14.2515C1.72104 14.5018 1.87547 14.7191 2.09791 14.8416C3.45707 15.5903 5.04526 16.1031 6.71353 16.3901C6.71942 16.4249 6.72585 16.4595 6.73283 16.494C6.82534 16.9512 7.01293 17.3846 7.28415 17.7657C7.58915 18.1943 7.99126 18.5446 8.45759 18.788C8.92393 19.0314 9.44125 19.161 9.96725 19.1662C10.4933 19.1713 11.013 19.0519 11.484 18.8177C11.9551 18.5835 12.364 18.2412 12.6773 17.8187C12.956 17.4429 13.152 17.0133 13.2535 16.558C13.2659 16.5024 13.2769 16.4464 13.2864 16.3901C14.9547 16.1031 16.5429 15.5903 17.902 14.8416C18.1245 14.7191 18.2789 14.5018 18.3215 14.2515C18.3641 14.0011 18.2902 13.745 18.1208 13.5558C17.4354 12.7903 17.1008 11.8262 16.8934 10.7052C16.7908 10.1507 16.723 9.58131 16.6524 8.98831L16.6498 8.9666C16.5796 8.37643 16.5057 7.75942 16.3903 7.16686C16.16 5.98449 15.7414 4.76573 14.7066 3.86504C13.9601 3.21525 12.9659 2.79326 11.6628 2.60796ZM11.4735 16.6118C10.9833 16.6482 10.491 16.6663 9.99997 16.6663C9.50894 16.6663 9.01659 16.6482 8.52646 16.6118C8.56072 16.6766 8.59931 16.7393 8.64206 16.7994C8.79456 17.0137 8.99561 17.1888 9.22878 17.3105C9.46195 17.4322 9.72061 17.497 9.98361 17.4996C10.2466 17.5022 10.5065 17.4425 10.742 17.3254C10.9775 17.2083 11.182 17.0371 11.3387 16.8258C11.3891 16.7578 11.4341 16.6862 11.4735 16.6118ZM9.99997 14.9997C7.7643 14.9997 5.56043 14.5915 3.75964 13.8033C4.29804 12.9144 4.57237 11.9432 4.74534 11.0085C4.85786 10.4004 4.9311 9.78486 4.99974 9.20802L5.00502 9.16361C5.07647 8.56336 5.14379 8.00756 5.24547 7.48548C5.44936 6.43857 5.76868 5.66075 6.38743 5.12218C7.00431 4.58523 8.05916 4.16634 9.99991 4.16634C11.9406 4.16634 12.9955 4.58523 13.6124 5.12218C14.2311 5.66076 14.5505 6.43858 14.7544 7.4855C14.8561 8.00758 14.9234 8.56338 14.9949 9.16362L15.0001 9.20803C15.0688 9.78487 15.142 10.4004 15.2546 11.0085C15.4276 11.9433 15.7019 12.9144 16.2403 13.8033C14.4395 14.5915 12.2356 14.9997 9.99997 14.9997Z" fill="#1E1E1E"/>
                </svg>
            </div>
            <div class="pt-0.5 rounded-full z-20 absolute top-2.5 right-4 w-5 h-5 bg-secondary text-primary text-sm text-center">
                6
            </div>
        </div>
        <section class="outer-border w-32 h-52 border-secondaryp-2.5">
            <section class=" border border-secondary justify-self-end rounded-sm text-center pt-10 flex flex-col flex-wrap place-content-between" on:click={() => page.route('/users')}>
                <section class="flex flex-row flex-wrap w-28 gap-3 justify-center">
                    {#each $users.slice(0,4) as userProfile}
                        <div class="btn-sm w-11 h-11">
                            <img src="/img/profiles/{userProfile.uid}.png" class="rounded-full" alt="U" referrerpolicy="no-referrer">
                        </div>
                    {/each}    
                </section>
                <span class="mb-8">My home</span>
            </section>
        </section>
        <div class="border-secondary border w-32 h-52 justify-self-end rounded-sm text-center px-4 pt-8 z-0" on:click={() => page.route('/lists')}  >
            <span>Shopping</span>
            <section class="flex flex-row px-6 flex-wrap gap-3 justify-center pt-3.5">
                {#each shortLists as list}
                <div class="btn-sm w-11 h-11 z-10" on:click|stopPropagation={() => page.route('/lists/items?list_uid='+list.uid)}>
                    {#if list.storeId}
                        <img alt="" class="rounded-full border border-primary" src="/img/stores/{list.storeLogo}.png" />
                    {:else}
                        <img alt="" class="w-7" src="/img/icon/retailers/de55.png" />
                    {/if}
                </div> 
                {/each}
            </section>
        </div>
    </section>
</section>
-->
<!--Nav /-->

<style lang="postcss">
    section {
        /*@apply border border-shade;*/
    }
</style>
